var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "169px",
    height: "144px",
    viewBox: "0 0 169 144",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-84.000000, -96.000000)",
    stroke: "currentColor",
    strokeWidth: 12
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 90,
    y: 102,
    width: 157,
    height: 132,
    rx: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90,
    y1: 139,
    x2: 247,
    y2: 139,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.5,
    y1: 139.455446,
    x2: 130.5,
    y2: 230.544554,
    id: "Line-2",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168.5,
    y1: 139.455446,
    x2: 168.5,
    y2: 230.544554,
    id: "Line-2",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.5,
    y1: 139.455446,
    x2: 206.5,
    y2: 230.544554,
    id: "Line-2",
    strokeLinecap: "square"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.f1a904592f72b8a4cd013e74bf000ff1.svg";
export { ForwardRef as ReactComponent };